module.exports = __webpack_public_path__ + "img/mb-poster-fallback-image.9bdf2b44.jpeg";